import React, { ReactNode } from 'react';

import { pipe } from 'fp-ts/function';
import * as RD from 'fp-ts-remote-data';
import { HttpError, HttpRemoteData } from '@core/http';
import { DebouncedLineLoader } from '@layout/loaders/line-loader/LineLoader';
import ErrorPage from '@shared/components/error-page/ErrorPage';

export function renderHttpRemoteData<E, A, R extends ReactNode>(
  value: HttpRemoteData<A, E>,
  onSuccess: (data: A) => R,
  onLoading: () => R | JSX.Element = () => <DebouncedLineLoader />,
  onError: (error: HttpError<E>) => R | JSX.Element = error => <ErrorPage error={error} />,
): R | JSX.Element {
  return pipe(value, RD.fold(onLoading, onSuccess, onError));
}
